export function isContainerWorkspaceType(type: string) {
  return ["container", "process-sandbox", "rootless-podman"].includes(type);
}

export type AgentWorkspaceMode = "isolated" | "machine";

export function normalizeAgentWorkspaceMode(
  mode?: AgentWorkspaceMode | null,
): AgentWorkspaceMode {
  return mode === "machine" ? "machine" : "isolated";
}
